// Wachtwoord vergeten — M115 safety-follow-up
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, Mail } from "lucide-react";


export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [mailEnabled, setMailEnabled] = useState(null);

  useEffect(() => {
    api.get("/auth/password-reset/config")
      .then((r) => setMailEnabled(!!r.data.mail_enabled))
      .catch(() => setMailEnabled(false));
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg(null);
    try {
      const r = await api.post("/auth/password-reset/request", { email });
      setMsg(r.data.message_nl || "Aanvraag ontvangen.");
    } catch (e) {
      setMsg("Er ging iets mis. Probeer het later opnieuw.");
    }
    finally { setBusy(false); }
  };

  return (
    <div data-testid="forgot-page" className="min-h-screen flex items-center justify-center bg-bg-canvas px-4">
      <div className="w-full max-w-md rounded-md border border-border-hairline bg-bg-panel p-6">
        <h1 className="text-2xl font-semibold text-text-primary mb-1" data-testid="forgot-title">
          Wachtwoord vergeten
        </h1>
        <p className="text-sm text-text-muted mb-4">
          Vul uw e-mailadres in. Als het bekend is bij JustEasySEO, sturen wij u een herstellink.
        </p>

        {mailEnabled === false && (
          <div data-testid="forgot-mail-disabled" className="p-3 mb-3 rounded border border-warn-amber/40 bg-warn-amber/10 text-xs text-warn-amber">
            E-mailbezorging is momenteel niet ingesteld op deze omgeving. Neem contact op met de beheerder om uw wachtwoord te herstellen.
          </div>
        )}

        <form onSubmit={submit}>
          <label className="text-[10px] text-text-muted">E-mailadres</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                  data-testid="forgot-email-input"
                  className="w-full mt-1 mb-3 bg-bg-panel-raised border border-border-hairline rounded px-2 py-1.5 text-sm text-text-primary" />
          <button type="submit" disabled={busy || !email.trim() || mailEnabled === false}
                    data-testid="forgot-submit-btn"
                    className="w-full h-10 rounded-md bg-accent-teal hover:bg-accent-teal-dim disabled:opacity-60 text-white text-sm font-semibold inline-flex items-center justify-center gap-1.5">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Mail className="w-4 h-4" />}
            Verstuur herstellink
          </button>
        </form>

        {msg && (
          <div data-testid="forgot-response-msg" className="mt-3 p-3 rounded border border-info-blue/40 bg-info-blue/10 text-xs text-info-blue">
            {msg}
          </div>
        )}

        <div className="mt-4 text-center">
          <Link to="/login" data-testid="forgot-back-to-login" className="text-xs text-text-muted hover:text-accent-teal underline">
            Terug naar inloggen
          </Link>
        </div>
      </div>
    </div>
  );
}
